import React, { useState } from "react";
import { Select, Form, InputNumber } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CircleCheck, Sparkles } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import FormItem from "components/fields/FormItem";

const { Option } = Select;

const employees = [
  { name: "Ashley Palma", code: "EMP001", role: "Senior Developer", dept: "Engineering" },
  { name: "Saccharine Elupre", code: "EMP002", role: "Marketing Manager", dept: "Marketing" },
  { name: "Emily Rodriguez", code: "EMP003", role: "Frontend Developer", dept: "Engineering" },
  { name: "James Wilson", code: "EMP004", role: "HR Specialist", dept: "HR" },
  { name: "Lisa Anderson", code: "EMP005", role: "Financial Analyst", dept: "Finance" },
  { name: "David Martinez", code: "EMP006", role: "DevOps Engineer", dept: "Engineering" },
  { name: "Jennifer Lee", code: "EMP007", role: "UX Designer", dept: "Design" },
  { name: "Robert Taylor", code: "EMP008", role: "Sales Director", dept: "Sales" },
  { name: "Acee Cayanan", code: "EMP009", role: "Creative Director", dept: "Design" },
];

const AwardeeSelector = ( props ) => {
  const { creditsAmount, category } = props;

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  return (
    <Form layout="vertical">
      <div className="space-y-4">
        <FormItem label="Select Team Member *" name="team member">
                <Select
                  showSearch
                  placeholder="Choose a team member to reward"
                  optionFilterProp="children"
                  onChange={(value) => setSelectedEmployee(value)}
                  suffixIcon={<SearchOutlined />}
                  dropdownStyle={{ maxHeight: 300, overflowY: "auto" }}
                  value={selectedEmployee}
                  optionLabelProp="value" 
                >
                  {employees.map((emp) => (
                    <Option
                      key={emp.code}
                      value={emp.name} 
                    >
                      <div className="flex flex-col">
                        <div className="flex justify-start items-center gap-2 px-2">
                            <div className="w-4 flex justify-center">
                              <CircleCheck
                                size={16}
                                className={selectedEmployee === emp.name ? "opacity-100" : "opacity-0"}
                              />
                            </div>
                          <div className="flex flex-col">
                            <span>{emp.name}</span>
                            <span style={{ fontSize: 11, color: "#888" }}>
                              {emp.role} • {emp.dept}
                            </span>
                          </div>
                          </div>
                        </div>
                    </Option>
                  ))}
                </Select>
              </FormItem>
              <FormItem
                label="Gift credits amount"
                name="reason"
                rules={[{ required: true, message: "Please provide a credit amount" }]}
              >
                <InputNumber
                  id="credits"
                  min={1}
                  placeholder="Enter credit amount"
                  defaultValue={creditsAmount} 
                  style={{
                    width: "100%",
                    borderRadius: "8px", 
                    fontSize: "14px",
                  }}
                />
                <p class="text-[11px] text-gray-600">Suggested: {creditsAmount}  credits for this category</p>
              </FormItem>
              <FormItem
                label="Reason for award"
                name="reason"
                rules={[{ required: true, message: "Please provide a reason..." }]}
              >
                <TextArea
                  id="examples"
                  className="input-field"
                  maxLength={255}
                  placeholder="Describe the specific achievement or contribution..."
                />
              </FormItem>

              <div className={`flex card-theme ${category} gap-2 rounded-xl p-4 `}>
                <div className="p-2">
                  <Sparkles className="h-5 w-5 card-text"/>
                </div>
                <div className="card-text">
                    <p className="text-[13px]">Award Tips</p> 
                    <p className="text-[12px] font-medium">Be specific about the achievement. Include measurable results, dates, or project names to make the recognition meaningful and memorable.</p>
                </div>
              </div>
      </div>
    </Form>
    
  );
};

export default AwardeeSelector;
